export const ADD_CAR_TO_BATCH = 'ADD_CAR_TO_BATCH';
export const REMOVE_CAR_FROM_BATCH = 'REMOVE_CAR_FROM_BATCH';
export const DISABLE_CARS_FROM_BATCH = 'DISABLE_CARS_FROM_BATCH';
export const RESET_BATCH = 'RESET_BATCH';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const ENABLE_CARS_FROM_BATCH = 'ENABLE_CARS_FROM_BATCH';

/*FILTERS*/

export const SET_FILTERS = 'SET_FILTERS';
export const RESET_FILTERS = 'RESET_FILTERS';
export const SET_INITIAL_FILTERS = 'SET_INITIAL_FILTERS';

/* CLOSED BATCHES */

export const SET_CLOSED_BATCHES = 'SET_CLOSED_BATCHES';
export const UPDATE_CLOSED_BATCH = 'UPDATE_CLOSED_BATCH';
export const SELECT_CLOSED_BATCH = 'SELECT_CLOSED_BATCH';
export const ACTIVATE_CLOSED_BATCH = 'ACTIVATE_CLOSED_BATCH';

/*AUCTIONS*/

export const SET_VEHICLES_LIST = 'SET_VEHICLES_LIST';
export const UPDATE_VEHICLES_LIST = 'UPDATE_VEHICLES_LIST';
export const RESET_VEHICLES_LIST = 'RESET_VEHICLES_LIST';
export const BLOCK_VEHICLES_LIST = 'BLOCK_VEHICLES_LIST';

/* RENTING RED-RAC */

export const SET_RENTING_RED_RAC_LIST = 'SET_RENTING_RED_RAC_LIST';
export const REMOVE_RENTING_RED_RAC_VEHICLE = 'REMOVE_RENTING_RED_RAC_VEHICLE';
